/* istanbul ignore file */

import { useContext, useMemo, VFC } from 'react'
import {
  ConnectedTable,
  TableProvider,
  ConnectedTableLayout,
} from '@panwds/react-table'
import V5TableWrapper from '../../../../../../common/components/table/V5TableWrapper'
import { LABEL_ALL_APPS_SERVICES, LABEL_ROLES } from '../../../../../constants/LabelConstants'
import TableHeader from '../../../../../../common/components/table/TableHeader'
import styled from 'styled-components'

import InheritedCellRenderer from './cellRenderer/InheritedCellRenderer'
import RoleRenderer from './cellRenderer/RoleRenderer'
import IAMAppName from '../../../../../utils/IAMAppName'
import AppContext from '../../../../../../common/context/AppContext'

const CONTAINER = styled(V5TableWrapper)`
  div[data-testid="connected-table-layout"] {
    min-height: auto !important;
    position: absolute;
    inset: 0 0 0 0;
    & > div {
      height: 100%;
    }
  }
  div {
    &.tw-scrollbar-default {
      min-height: 0 !important;
    }
    &.tw-flex-grow.tw-overflow-auto {
      min-height: 0 !important;
    }
  }
`

const UserRolesTable: VFC<{
  member: any
}> = ({
  member
}) => {

  const { getAppName } = useContext((AppContext))

  const data = useMemo(() => {
    const appPolicies: { [key: string]: any } = {}
    const apps: Set<string> = new Set<string>()
    for (const policy of member?.policies) {
      const { resource } = policy
      const app_id: string = resource.app_id as string
      if (!apps.has(app_id)) {
        apps.add(app_id)
      }
      if (!appPolicies[app_id]) {
        appPolicies[app_id] = []
      }
      appPolicies[app_id].push(policy)
    }
    return [...apps].map((app_id) => ({
      appName: app_id ? IAMAppName(app_id, getAppName) : LABEL_ALL_APPS_SERVICES,
      policies: appPolicies[app_id]
    }))
  }, [member, getAppName])

  const columns = useMemo(() => [
    {
      Header: 'Applications',
      id: 'applications',
      accessor: 'appName',
      width: 175,
      Cell: ({ value }: any) => (
        <div className='tw-h-full tw-p-1'>
          {value}
        </div>
      )
    },
    {
      Header: 'Role',
      id: 'role',
      accessor: 'id',
      width: 200,
      Cell: RoleRenderer
    },
    {
      Header: 'Inherited From',
      id: 'inherited',
      accessor: 'id',
      Cell: InheritedCellRenderer
    }
  ], [])

  return (
    <CONTAINER className='tw-w-full tw-h-full tw-flex tw-flex-col'>
      <TableProvider
        columns={columns as any}
        data={data}
        enablePagination
        enableResizeColumns
        enableColumnOrder
      >
        <TableHeader title={LABEL_ROLES}/>
        <div className='tw-relative tw-h-full'>
          <ConnectedTableLayout
            sidecar={<div/>}
            overflow
            resultsSummary={false}
          >
            <ConnectedTable
              showFooter={false}
            />
          </ConnectedTableLayout>
        </div>
      </TableProvider>
    </CONTAINER>
  )
}

export default UserRolesTable
